import React, {Component, Fragment} from 'react';
import _ from 'lodash';

import JqDatePicker from '../../lib/mxjslib/mx.react.jquery-ui.datepicker.min';

import {Time} from '../../util';
import CheckBox from '../checkbox';


class DatePickerSingleChk extends Component {


  componentDidMount(){
    const {defaultDate = Time.getToday()} = this.props;
    if(this.props.checked) JqDatePicker.func('setDate', defaultDate);
  }
  
  componentDidUpdate(prevProps, prevState){
    const {defaultDate = Time.getToday()} = this.props;
    if(prevProps.checked !== this.props.checked){
      if(this.props.checked) JqDatePicker.func('setDate', defaultDate);
    }
  }
  calendarOption(){
    const {onSelect} = this.props;
    const options = {
      inline: true,
      yearSuffix: ' -',
      domType: 'input',
      dateFormat: 'yy-mm-dd',
      dayNames: ['일', '월', '화', '수', '목', '금', '토'],
      dayNamesShort: ['일', '월', '화', '수', '목', '금', '토'],
      dayNamesMin: ['일', '월', '화', '수', '목', '금', '토'],
      monthNames: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
      monthNamesShort: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
      showMonthAfterYear: true,
      onSelect: (dateText) => {
        if(onSelect) onSelect(dateText);
      },
    };
    return options;
  }

 
  render() {
    const {
      id,
      checked,
      handleOnClick,
      defaultDate
    } = this.props;
    return (
      <Fragment>
        <CheckBox id={`${id}_checkbox`}
          handleOnClick={handleOnClick}
          checked={checked}/>
          {checked ?
            <JqDatePicker {...this.calendarOption()} />
            :
            <input type="text" className="hasDatepicker" value={defaultDate} disabled />
          } 
      </Fragment>
    );
  }
}

export default DatePickerSingleChk;


// WEBPACK FOOTER //
// ./src/components/datepicker/singleChk.js